export interface IPurchaseOrder {
  purchaseOrderId: number | null
  poNumber: string
  supplier: string
  notes: string
  closedNotes?: string
  poDate: Date | null
  type: string
  status: string
  lastModifiedEmployeeId: string
  createdAt: Date | null
  createdBy: string
  cancelledDate: Date | null
  closedDate: Date | null
  closedBy?: string
  purchaseOrderItems?: IPurchaseOrderItem[]
}

export class PurchaseOrder {
  purchaseOrderId: number | null
  poNumber: string
  supplier: string
  notes: string
  closedNotes?: string
  poDate: Date | null
  type: string
  status: string
  lastModifiedEmployeeId: string
  createdAt: Date | null
  createdBy: string
  cancelledDate: Date | null
  closedDate: Date | null
  closedBy?: string
  purchaseOrderItems?: IPurchaseOrderItem[]

  constructor({
    purchaseOrderId,
    poNumber,
    supplier,
    notes,
    closedNotes,
    poDate,
    type,
    status,
    lastModifiedEmployeeId,
    createdAt,
    createdBy,
    cancelledDate,
    closedDate,
    closedBy,
    purchaseOrderItems,
  }: Partial<IPurchaseOrder>) {
    this.purchaseOrderId = purchaseOrderId ?? null
    this.poNumber = poNumber || ''
    this.supplier = supplier || ''
    this.notes = notes || ''
    this.closedNotes = closedNotes || ''
    this.poDate = poDate ? new Date(poDate) : null
    this.type = type || ''
    this.status = status || ''
    this.lastModifiedEmployeeId = lastModifiedEmployeeId || ''
    this.createdAt = createdAt ? new Date(createdAt) : null
    this.cancelledDate = cancelledDate ? new Date(cancelledDate) : null
    this.closedDate = closedDate ? new Date(closedDate) : null
    this.closedBy = closedBy || ''
    this.createdBy = createdBy || ''
    this.purchaseOrderItems = purchaseOrderItems
      ? purchaseOrderItems.map((item) => new PurchaseOrderItem(item))
      : undefined
  }
}

export interface IPurchaseOrderItem {
  purchaseOrderItemId: number | null
  purchaseOrderId: number | null
  itemId: string
  itemName: string
  notes: string
  unitPrice: number | null
  taxType: string
  discount: number | null
  quantityPurchased: number | null
  quantityReceived: number | null
  totalPrice: number | null
  lastModifedEmployeeId: string
  createdAt: Date | null
  createdBy: string
  receivedNotes?: string
  closedNotes?: string
  receivedDate?: Date | null
}

export class PurchaseOrderItem {
  purchaseOrderItemId: number | null
  purchaseOrderId: number | null
  itemId: string
  itemName: string
  notes: string
  unitPrice: number | null
  taxType: string
  discount: number | null
  quantityPurchased: number | null
  quantityReceived: number | null
  totalPrice: number | null
  lastModifedEmployeeId: string
  createdAt: Date | null
  createdBy: string
  receivedDate?: Date | null

  constructor({
    purchaseOrderItemId,
    purchaseOrderId,
    itemId,
    itemName,
    notes,
    unitPrice,
    taxType,
    discount,
    quantityPurchased,
    quantityReceived,
    totalPrice,
    lastModifedEmployeeId,
    createdAt,
    createdBy,
    receivedDate,
  }: Partial<IPurchaseOrderItem>) {
    this.purchaseOrderItemId = purchaseOrderItemId ?? null
    this.purchaseOrderId = purchaseOrderId ?? null
    this.itemId = itemId || ''
    this.itemName = itemName || ''
    this.notes = notes || ''
    this.unitPrice = unitPrice ?? null
    this.taxType = taxType || ''
    this.discount = discount ?? null
    this.quantityPurchased = quantityPurchased ?? null
    this.quantityReceived = quantityReceived ?? null
    this.totalPrice = totalPrice ?? null
    this.lastModifedEmployeeId = lastModifedEmployeeId || ''
    this.createdAt = createdAt ? new Date(createdAt) : null
    this.createdBy = createdBy || ''
    this.receivedDate = receivedDate ? new Date(receivedDate) : null
  }
}
